import axios from '../../plugins/axios'

export const sendEmail = (_, { data }) => {
  return axios.post('/api/utils/send-email', data)
    .catch(err => err.response)
}
